export default __webpack_public_path__ + "static/car_insurance-1--19e6bdd212611c8501c5f3cff4c662b4.png";